import isEmpty from "lodash/isEmpty";
import axios from "axios";

import { TOGGLE_UNBOUNCE_MODAL, SUBMIT_UNBOUNCE_SUCCESS, SUBMIT_UNBOUNCE, SUBMIT_UNBOUNCE_FAIL } from "../actionTypes";
import { API_URL, UNBOUNCE_SUBMITED_TIMESTAMP, UNBOUNCE_LOCALSTORAGE_KEY } from "../../constants";

export const toggleUnbounceModal = () => (dispatch, getState) => {
  const { unBounceModal } = getState();

  if (unBounceModal.unbounceModalShow) {
    // Wrap localStorage writes — Safari private mode + quota-exceeded
    // throw, and an unhandled exception here crashes the entire
    // dispatch (the modal toggle never fires, the user is stuck).
    try {
      localStorage.setItem(UNBOUNCE_SUBMITED_TIMESTAMP, new Date().getTime());
      localStorage.setItem(UNBOUNCE_LOCALSTORAGE_KEY, true);
    } catch (_e) {
      // ignore — the in-session redux state still suppresses the
      // modal until reload; only the cross-session "don't pop again"
      // signal is lost.
    }
  }

  dispatch({ type: TOGGLE_UNBOUNCE_MODAL });
};

export const submitUnbounce = (email) => (dispatch, getState) => {
  const { freeAssessment } = getState();
  const { selectedAddress } = freeAssessment;

  const payload = {
    email_address: email,
    source: "UnbounceForm",
    notes: "10% Discount",
    prop: null,
  };

  if (!isEmpty(selectedAddress)) {
    payload.prop = `${selectedAddress.county} - ${selectedAddress.assessor_id}`;
  }

  dispatch(submitUnbounceStart());
  axios
    .post(`${API_URL}/leads/`, payload)
    .then((res) => {
      dispatch(submitUnbounceSuccess(res));
    })
    .catch(() => dispatch(submitUnbounceFail()));
};

export const submitUnbounceStart = () => ({
  type: SUBMIT_UNBOUNCE,
});

export const submitUnbounceSuccess = () => ({
  type: SUBMIT_UNBOUNCE_SUCCESS,
});

export const submitUnbounceFail = () => ({
  type: SUBMIT_UNBOUNCE_FAIL,
});
